import React from 'react';
import styled from 'styled-components/macro';
import { IconUserPhoto } from '../../icons';
import { Heading } from '../../typography';
import { SPACINGS } from '../../utils';

const UserPhotoStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  .image {
    width: 100px;
    height: 100px;
    margin-bottom: ${SPACINGS[4]};

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }
`;

type UserPhotoProps = {
  name: string;
  photo?: string;
  style?: React.CSSProperties;
};
function UserPhoto(props: UserPhotoProps) {
  const { name, photo, style } = props;

  return (
    <UserPhotoStyled style={style}>
      <div className="image">
        {photo ? <img src={photo} alt="User profile" /> : <IconUserPhoto />}
      </div>
      <Heading type={2} weight="bold" align="center">
        {name}
      </Heading>
    </UserPhotoStyled>
  );
}

export default UserPhoto;
